export default {
  DARK: {
    heading: p => p.primaryLight,
    background: p => p.tertiaryDark,
    border: p => p.primaryLight,
    lightBackground: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryDark
  },
  LIGHT: {
    heading: p => p.primaryDark,
    background: p => p.tertiaryLight,
    border: p => p.primaryDark,
    lightBackground: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryLight
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    background: p => p.tertiaryExtraLight,
    border: p => p.primaryDark,
    lightBackground: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryExtraLight
  }
}
